"use strict";
angular.module('departmentManuLeftModule', [])
    .controller('departmentManuLeftCtrl', ['$scope', '$q', '$stateParams', 'permissionService', '$element', '$location', '$state', '$timeout', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'departmentManuCommonService',
        function($scope, $q, $stateParams, permissionService, $element, $location, $state, $timeout, treeService, trsHttpService, modalDialog, trsspliceString, departmentManuCommonService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化参数状态1
             */
            function initStatus() {
                $scope.status = {
                    toRightDepartModuleIndex: -1,
                    eventShowChildren: true,
                }
            }

            function initData() {
                requestCompanyList();
                companyManageList();
                headerDepartmentBroadcast();
                autoGo();
            }

            /**
             * [toRightDepartModule description] 根据左侧单位获取右侧部门
             */
            $scope.toRightDepartModule = function(item, index) {
                $scope.status.toRightDepartModuleIndex = index;
                $state.go('manageconfig.departmentmanu.departmentmanage', { parentid: item.DEPARTMENTALDOCID }, { reload: 'manageconfig.departmentmanu.departmentmanage' });
            };
            /**
             * [requestCompanyList description] 获取单位列表
             */
            function requestCompanyList() {
                $scope.queryCompanyParams = {
                    serviceid: "mlf_departdoc",
                    methodname: "queryDeparts",
                    ParentId: 0,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.queryCompanyParams, "get").then(function(data) {
                    if (data.PAGER == undefined) {//兼容后端返回无数据时,返回数据结构不一致问题
                        $scope.companyList = data; 
                    }else{
                        $scope.companyList = [];
                    }
                    $scope.status.eventShowChildren = !$scope.companyList.length ? false : true;
                });
            }

            /**
             * [companyManageList description] 监控右侧子组织调整顺序
             * @return {[type]} [description]
             */
            function companyManageList() {
                $scope.$on("companyManageList", function() {
                    requestCompanyList();
                });
            }

            function headerDepartmentBroadcast() {
                $scope.$on("departmentBroadcast", function() {
                    $scope.status.toRightDepartModuleIndex = -1;
                });
            }
            /**
             * [autoGo description] 自动跳转
             * @return {[type]} [description]
             */
            function autoGo() {
                var pathArray = window.location.href.split("?")[0].split('/');
                if (pathArray[pathArray.length - 1] == 'departmentmanu') {
                    $timeout(function() {
                        $element.find("li").eq(0).find("a")[0].click();
                        if ($element.find("li").eq(0).find("li").length > 0) {
                            $element.find("li").eq(0).find("li").find("a")[0].click();
                            $scope.status.eventShowChildren = true;
                            $scope.status.toRightDepartModuleIndex = 0;
                        }
                    });
                }
            }
        }
    ]);